import { _ as n, a as e, b as a, d as r, e as t } from "./_commonjsHelpers-b0e8727a.js";
import S, { PureComponent as I } from "react";
import { P as O } from "./index-f450c016.js";
var i = [{
  ISO2: "AW",
  ISO3: "ABW",
  name: "Aruba"
}, {
  ISO2: "AF",
  ISO3: "AFG",
  name: "Afghanistan"
}, {
  ISO2: "AO",
  ISO3: "AGO",
  name: "Angola"
}, {
  ISO2: "AI",
  ISO3: "AIA",
  name: "Anguilla"
}, {
  ISO2: "AX",
  ISO3: "ALA",
  name: "Åland Islands"
}, {
  ISO2: "AL",
  ISO3: "ALB",
  name: "Albania"
}, {
  ISO2: "AD",
  ISO3: "AND",
  name: "Andorra"
}, {
  ISO2: "AE",
  ISO3: "ARE",
  name: "United Arab Emirates"
}, {
  ISO2: "AR",
  ISO3: "ARG",
  name: "Argentina"
}, {
  ISO2: "AM",
  ISO3: "ARM",
  name: "Armenia"
}, {
  ISO2: "AS",
  ISO3: "ASM",
  name: "American Samoa"
}, {
  ISO2: "AQ",
  ISO3: "ATA",
  name: "Antarctica"
}, {
  ISO2: "TF",
  ISO3: "ATF",
  name: "French Southern and Antarctic Lands"
}, {
  ISO2: "AG",
  ISO3: "ATG",
  name: "Antigua and Barbuda"
}, {
  ISO2: "AU",
  ISO3: "AUS",
  name: "Australia"
}, {
  ISO2: "AT",
  ISO3: "AUT",
  name: "Austria"
}, {
  ISO2: "AZ",
  ISO3: "AZE",
  name: "Azerbaijan"
}, {
  ISO2: "BI",
  ISO3: "BDI",
  name: "Burundi"
}, {
  ISO2: "BE",
  ISO3: "BEL",
  name: "Belgium"
}, {
  ISO2: "BJ",
  ISO3: "BEN",
  name: "Benin"
}, {
  ISO2: "BF",
  ISO3: "BFA",
  name: "Burkina Faso"
}, {
  ISO2: "BD",
  ISO3: "BGD",
  name: "Bangladesh"
}, {
  ISO2: "BG",
  ISO3: "BGR",
  name: "Bulgaria"
}, {
  ISO2: "BH",
  ISO3: "BHR",
  name: "Bahrain"
}, {
  ISO2: "BS",
  ISO3: "BHS",
  name: "Bahamas"
}, {
  ISO2: "BA",
  ISO3: "BIH",
  name: "Bosnia and Herzegovina"
}, {
  ISO2: "BL",
  ISO3: "BLM",
  name: "Saint Barthélemy"
}, {
  ISO2: "SH",
  ISO3: "SHN",
  name: "Saint Helena, Ascension and Tristan da Cunha"
}, {
  ISO2: "BY",
  ISO3: "BLR",
  name: "Belarus"
}, {
  ISO2: "BZ",
  ISO3: "BLZ",
  name: "Belize"
}, {
  ISO2: "BM",
  ISO3: "BMU",
  name: "Bermuda"
}, {
  ISO2: "BO",
  ISO3: "BOL",
  name: "Bolivia"
}, {
  ISO2: "BQ",
  ISO3: "BES",
  name: "Caribbean Netherlands"
}, {
  ISO2: "BR",
  ISO3: "BRA",
  name: "Brazil"
}, {
  ISO2: "BB",
  ISO3: "BRB",
  name: "Barbados"
}, {
  ISO2: "BN",
  ISO3: "BRN",
  name: "Brunei"
}, {
  ISO2: "BT",
  ISO3: "BTN",
  name: "Bhutan"
}, {
  ISO2: "BV",
  ISO3: "BVT",
  name: "Bouvet Island"
}, {
  ISO2: "BW",
  ISO3: "BWA",
  name: "Botswana"
}, {
  ISO2: "CF",
  ISO3: "CAF",
  name: "Central African Republic"
}, {
  ISO2: "CA",
  ISO3: "CAN",
  name: "Canada"
}, {
  ISO2: "CC",
  ISO3: "CCK",
  name: "Cocos (Keeling) Islands"
}, {
  ISO2: "CH",
  ISO3: "CHE",
  name: "Switzerland"
}, {
  ISO2: "CL",
  ISO3: "CHL",
  name: "Chile"
}, {
  ISO2: "CN",
  ISO3: "CHN",
  name: "China"
}, {
  ISO2: "CI",
  ISO3: "CIV",
  name: "Ivory Coast"
}, {
  ISO2: "CM",
  ISO3: "CMR",
  name: "Cameroon"
}, {
  ISO2: "CD",
  ISO3: "COD",
  name: "DR Congo"
}, {
  ISO2: "CG",
  ISO3: "COG",
  name: "Republic of the Congo"
}, {
  ISO2: "CK",
  ISO3: "COK",
  name: "Cook Islands"
}, {
  ISO2: "CO",
  ISO3: "COL",
  name: "Colombia"
}, {
  ISO2: "KM",
  ISO3: "COM",
  name: "Comoros"
}, {
  ISO2: "CV",
  ISO3: "CPV",
  name: "Cape Verde"
}, {
  ISO2: "CR",
  ISO3: "CRI",
  name: "Costa Rica"
}, {
  ISO2: "CU",
  ISO3: "CUB",
  name: "Cuba"
}, {
  ISO2: "CW",
  ISO3: "CUW",
  name: "Curaçao"
}, {
  ISO2: "CX",
  ISO3: "CXR",
  name: "Christmas Island"
}, {
  ISO2: "KY",
  ISO3: "CYM",
  name: "Cayman Islands"
}, {
  ISO2: "CY",
  ISO3: "CYP",
  name: "Cyprus"
}, {
  ISO2: "CZ",
  ISO3: "CZE",
  name: "Czechia"
}, {
  ISO2: "DE",
  ISO3: "DEU",
  name: "Germany"
}, {
  ISO2: "DJ",
  ISO3: "DJI",
  name: "Djibouti"
}, {
  ISO2: "DM",
  ISO3: "DMA",
  name: "Dominica"
}, {
  ISO2: "DK",
  ISO3: "DNK",
  name: "Denmark"
}, {
  ISO2: "DO",
  ISO3: "DOM",
  name: "Dominican Republic"
}, {
  ISO2: "DZ",
  ISO3: "DZA",
  name: "Algeria"
}, {
  ISO2: "EC",
  ISO3: "ECU",
  name: "Ecuador"
}, {
  ISO2: "EG",
  ISO3: "EGY",
  name: "Egypt"
}, {
  ISO2: "ER",
  ISO3: "ERI",
  name: "Eritrea"
}, {
  ISO2: "EH",
  ISO3: "ESH",
  name: "Western Sahara"
}, {
  ISO2: "ES",
  ISO3: "ESP",
  name: "Spain"
}, {
  ISO2: "EE",
  ISO3: "EST",
  name: "Estonia"
}, {
  ISO2: "ET",
  ISO3: "ETH",
  name: "Ethiopia"
}, {
  ISO2: "FI",
  ISO3: "FIN",
  name: "Finland"
}, {
  ISO2: "FJ",
  ISO3: "FJI",
  name: "Fiji"
}, {
  ISO2: "FK",
  ISO3: "FLK",
  name: "Falkland Islands"
}, {
  ISO2: "FR",
  ISO3: "FRA",
  name: "France"
}, {
  ISO2: "FO",
  ISO3: "FRO",
  name: "Faroe Islands"
}, {
  ISO2: "FM",
  ISO3: "FSM",
  name: "Micronesia"
}, {
  ISO2: "GA",
  ISO3: "GAB",
  name: "Gabon"
}, {
  ISO2: "GB",
  ISO3: "GBR",
  name: "United Kingdom"
}, {
  ISO2: "GE",
  ISO3: "GEO",
  name: "Georgia"
}, {
  ISO2: "GG",
  ISO3: "GGY",
  name: "Guernsey"
}, {
  ISO2: "GH",
  ISO3: "GHA",
  name: "Ghana"
}, {
  ISO2: "GI",
  ISO3: "GIB",
  name: "Gibraltar"
}, {
  ISO2: "GN",
  ISO3: "GIN",
  name: "Guinea"
}, {
  ISO2: "GP",
  ISO3: "GLP",
  name: "Guadeloupe"
}, {
  ISO2: "GM",
  ISO3: "GMB",
  name: "Gambia"
}, {
  ISO2: "GW",
  ISO3: "GNB",
  name: "Guinea-Bissau"
}, {
  ISO2: "GQ",
  ISO3: "GNQ",
  name: "Equatorial Guinea"
}, {
  ISO2: "GR",
  ISO3: "GRC",
  name: "Greece"
}, {
  ISO2: "GD",
  ISO3: "GRD",
  name: "Grenada"
}, {
  ISO2: "GL",
  ISO3: "GRL",
  name: "Greenland"
}, {
  ISO2: "GT",
  ISO3: "GTM",
  name: "Guatemala"
}, {
  ISO2: "GF",
  ISO3: "GUF",
  name: "French Guiana"
}, {
  ISO2: "GU",
  ISO3: "GUM",
  name: "Guam"
}, {
  ISO2: "GY",
  ISO3: "GUY",
  name: "Guyana"
}, {
  ISO2: "HK",
  ISO3: "HKG",
  name: "Hong Kong"
}, {
  ISO2: "HM",
  ISO3: "HMD",
  name: "Heard Island and McDonald Islands"
}, {
  ISO2: "HN",
  ISO3: "HND",
  name: "Honduras"
}, {
  ISO2: "HR",
  ISO3: "HRV",
  name: "Croatia"
}, {
  ISO2: "HT",
  ISO3: "HTI",
  name: "Haiti"
}, {
  ISO2: "HU",
  ISO3: "HUN",
  name: "Hungary"
}, {
  ISO2: "ID",
  ISO3: "IDN",
  name: "Indonesia"
}, {
  ISO2: "IM",
  ISO3: "IMN",
  name: "Isle of Man"
}, {
  ISO2: "IN",
  ISO3: "IND",
  name: "India"
}, {
  ISO2: "IO",
  ISO3: "IOT",
  name: "British Indian Ocean Territory"
}, {
  ISO2: "IE",
  ISO3: "IRL",
  name: "Ireland"
}, {
  ISO2: "IR",
  ISO3: "IRN",
  name: "Iran"
}, {
  ISO2: "IQ",
  ISO3: "IRQ",
  name: "Iraq"
}, {
  ISO2: "IS",
  ISO3: "ISL",
  name: "Iceland"
}, {
  ISO2: "IL",
  ISO3: "ISR",
  name: "Israel"
}, {
  ISO2: "IT",
  ISO3: "ITA",
  name: "Italy"
}, {
  ISO2: "JM",
  ISO3: "JAM",
  name: "Jamaica"
}, {
  ISO2: "JE",
  ISO3: "JEY",
  name: "Jersey"
}, {
  ISO2: "JO",
  ISO3: "JOR",
  name: "Jordan"
}, {
  ISO2: "JP",
  ISO3: "JPN",
  name: "Japan"
}, {
  ISO2: "KZ",
  ISO3: "KAZ",
  name: "Kazakhstan"
}, {
  ISO2: "KE",
  ISO3: "KEN",
  name: "Kenya"
}, {
  ISO2: "KG",
  ISO3: "KGZ",
  name: "Kyrgyzstan"
}, {
  ISO2: "KH",
  ISO3: "KHM",
  name: "Cambodia"
}, {
  ISO2: "KI",
  ISO3: "KIR",
  name: "Kiribati"
}, {
  ISO2: "KN",
  ISO3: "KNA",
  name: "Saint Kitts and Nevis"
}, {
  ISO2: "KR",
  ISO3: "KOR",
  name: "South Korea"
}, {
  ISO2: "XK",
  ISO3: "UNK",
  name: "Kosovo"
}, {
  ISO2: "KW",
  ISO3: "KWT",
  name: "Kuwait"
}, {
  ISO2: "LA",
  ISO3: "LAO",
  name: "Laos"
}, {
  ISO2: "LB",
  ISO3: "LBN",
  name: "Lebanon"
}, {
  ISO2: "LR",
  ISO3: "LBR",
  name: "Liberia"
}, {
  ISO2: "LY",
  ISO3: "LBY",
  name: "Libya"
}, {
  ISO2: "LC",
  ISO3: "LCA",
  name: "Saint Lucia"
}, {
  ISO2: "LI",
  ISO3: "LIE",
  name: "Liechtenstein"
}, {
  ISO2: "LK",
  ISO3: "LKA",
  name: "Sri Lanka"
}, {
  ISO2: "LS",
  ISO3: "LSO",
  name: "Lesotho"
}, {
  ISO2: "LT",
  ISO3: "LTU",
  name: "Lithuania"
}, {
  ISO2: "LU",
  ISO3: "LUX",
  name: "Luxembourg"
}, {
  ISO2: "LV",
  ISO3: "LVA",
  name: "Latvia"
}, {
  ISO2: "MO",
  ISO3: "MAC",
  name: "Macau"
}, {
  ISO2: "MF",
  ISO3: "MAF",
  name: "Saint Martin"
}, {
  ISO2: "MA",
  ISO3: "MAR",
  name: "Morocco"
}, {
  ISO2: "MC",
  ISO3: "MCO",
  name: "Monaco"
}, {
  ISO2: "MD",
  ISO3: "MDA",
  name: "Moldova"
}, {
  ISO2: "MG",
  ISO3: "MDG",
  name: "Madagascar"
}, {
  ISO2: "MV",
  ISO3: "MDV",
  name: "Maldives"
}, {
  ISO2: "MX",
  ISO3: "MEX",
  name: "Mexico"
}, {
  ISO2: "MH",
  ISO3: "MHL",
  name: "Marshall Islands"
}, {
  ISO2: "MK",
  ISO3: "MKD",
  name: "Macedonia"
}, {
  ISO2: "ML",
  ISO3: "MLI",
  name: "Mali"
}, {
  ISO2: "MT",
  ISO3: "MLT",
  name: "Malta"
}, {
  ISO2: "MM",
  ISO3: "MMR",
  name: "Myanmar"
}, {
  ISO2: "ME",
  ISO3: "MNE",
  name: "Montenegro"
}, {
  ISO2: "MN",
  ISO3: "MNG",
  name: "Mongolia"
}, {
  ISO2: "MP",
  ISO3: "MNP",
  name: "Northern Mariana Islands"
}, {
  ISO2: "MZ",
  ISO3: "MOZ",
  name: "Mozambique"
}, {
  ISO2: "MR",
  ISO3: "MRT",
  name: "Mauritania"
}, {
  ISO2: "MS",
  ISO3: "MSR",
  name: "Montserrat"
}, {
  ISO2: "MQ",
  ISO3: "MTQ",
  name: "Martinique"
}, {
  ISO2: "MU",
  ISO3: "MUS",
  name: "Mauritius"
}, {
  ISO2: "MW",
  ISO3: "MWI",
  name: "Malawi"
}, {
  ISO2: "MY",
  ISO3: "MYS",
  name: "Malaysia"
}, {
  ISO2: "YT",
  ISO3: "MYT",
  name: "Mayotte"
}, {
  ISO2: "NA",
  ISO3: "NAM",
  name: "Namibia"
}, {
  ISO2: "NC",
  ISO3: "NCL",
  name: "New Caledonia"
}, {
  ISO2: "NE",
  ISO3: "NER",
  name: "Niger"
}, {
  ISO2: "NF",
  ISO3: "NFK",
  name: "Norfolk Island"
}, {
  ISO2: "NG",
  ISO3: "NGA",
  name: "Nigeria"
}, {
  ISO2: "NI",
  ISO3: "NIC",
  name: "Nicaragua"
}, {
  ISO2: "NU",
  ISO3: "NIU",
  name: "Niue"
}, {
  ISO2: "NL",
  ISO3: "NLD",
  name: "Netherlands"
}, {
  ISO2: "NO",
  ISO3: "NOR",
  name: "Norway"
}, {
  ISO2: "NP",
  ISO3: "NPL",
  name: "Nepal"
}, {
  ISO2: "NR",
  ISO3: "NRU",
  name: "Nauru"
}, {
  ISO2: "NZ",
  ISO3: "NZL",
  name: "New Zealand"
}, {
  ISO2: "OM",
  ISO3: "OMN",
  name: "Oman"
}, {
  ISO2: "PK",
  ISO3: "PAK",
  name: "Pakistan"
}, {
  ISO2: "PA",
  ISO3: "PAN",
  name: "Panama"
}, {
  ISO2: "PN",
  ISO3: "PCN",
  name: "Pitcairn Islands"
}, {
  ISO2: "PE",
  ISO3: "PER",
  name: "Peru"
}, {
  ISO2: "PH",
  ISO3: "PHL",
  name: "Philippines"
}, {
  ISO2: "PW",
  ISO3: "PLW",
  name: "Palau"
}, {
  ISO2: "PG",
  ISO3: "PNG",
  name: "Papua New Guinea"
}, {
  ISO2: "PL",
  ISO3: "POL",
  name: "Poland"
}, {
  ISO2: "PR",
  ISO3: "PRI",
  name: "Puerto Rico"
}, {
  ISO2: "KP",
  ISO3: "PRK",
  name: "North Korea"
}, {
  ISO2: "PT",
  ISO3: "PRT",
  name: "Portugal"
}, {
  ISO2: "PY",
  ISO3: "PRY",
  name: "Paraguay"
}, {
  ISO2: "PS",
  ISO3: "PSE",
  name: "Palestine"
}, {
  ISO2: "PF",
  ISO3: "PYF",
  name: "French Polynesia"
}, {
  ISO2: "QA",
  ISO3: "QAT",
  name: "Qatar"
}, {
  ISO2: "RE",
  ISO3: "REU",
  name: "Réunion"
}, {
  ISO2: "RO",
  ISO3: "ROU",
  name: "Romania"
}, {
  ISO2: "RU",
  ISO3: "RUS",
  name: "Russia"
}, {
  ISO2: "RW",
  ISO3: "RWA",
  name: "Rwanda"
}, {
  ISO2: "SA",
  ISO3: "SAU",
  name: "Saudi Arabia"
}, {
  ISO2: "SD",
  ISO3: "SDN",
  name: "Sudan"
}, {
  ISO2: "SN",
  ISO3: "SEN",
  name: "Senegal"
}, {
  ISO2: "SG",
  ISO3: "SGP",
  name: "Singapore"
}, {
  ISO2: "GS",
  ISO3: "SGS",
  name: "South Georgia"
}, {
  ISO2: "SJ",
  ISO3: "SJM",
  name: "Svalbard and Jan Mayen"
}, {
  ISO2: "SB",
  ISO3: "SLB",
  name: "Solomon Islands"
}, {
  ISO2: "SL",
  ISO3: "SLE",
  name: "Sierra Leone"
}, {
  ISO2: "SV",
  ISO3: "SLV",
  name: "El Salvador"
}, {
  ISO2: "SM",
  ISO3: "SMR",
  name: "San Marino"
}, {
  ISO2: "SO",
  ISO3: "SOM",
  name: "Somalia"
}, {
  ISO2: "PM",
  ISO3: "SPM",
  name: "Saint Pierre and Miquelon"
}, {
  ISO2: "RS",
  ISO3: "SRB",
  name: "Serbia"
}, {
  ISO2: "SS",
  ISO3: "SSD",
  name: "South Sudan"
}, {
  ISO2: "ST",
  ISO3: "STP",
  name: "São Tomé and Príncipe"
}, {
  ISO2: "SR",
  ISO3: "SUR",
  name: "Suriname"
}, {
  ISO2: "SK",
  ISO3: "SVK",
  name: "Slovakia"
}, {
  ISO2: "SI",
  ISO3: "SVN",
  name: "Slovenia"
}, {
  ISO2: "SE",
  ISO3: "SWE",
  name: "Sweden"
}, {
  ISO2: "SZ",
  ISO3: "SWZ",
  name: "Eswatini"
}, {
  ISO2: "SX",
  ISO3: "SXM",
  name: "Sint Maarten"
}, {
  ISO2: "SC",
  ISO3: "SYC",
  name: "Seychelles"
}, {
  ISO2: "SY",
  ISO3: "SYR",
  name: "Syria"
}, {
  ISO2: "TC",
  ISO3: "TCA",
  name: "Turks and Caicos Islands"
}, {
  ISO2: "TD",
  ISO3: "TCD",
  name: "Chad"
}, {
  ISO2: "TG",
  ISO3: "TGO",
  name: "Togo"
}, {
  ISO2: "TH",
  ISO3: "THA",
  name: "Thailand"
}, {
  ISO2: "TJ",
  ISO3: "TJK",
  name: "Tajikistan"
}, {
  ISO2: "TK",
  ISO3: "TKL",
  name: "Tokelau"
}, {
  ISO2: "TM",
  ISO3: "TKM",
  name: "Turkmenistan"
}, {
  ISO2: "TL",
  ISO3: "TLS",
  name: "Timor-Leste"
}, {
  ISO2: "TO",
  ISO3: "TON",
  name: "Tonga"
}, {
  ISO2: "TT",
  ISO3: "TTO",
  name: "Trinidad and Tobago"
}, {
  ISO2: "TN",
  ISO3: "TUN",
  name: "Tunisia"
}, {
  ISO2: "TR",
  ISO3: "TUR",
  name: "Turkey"
}, {
  ISO2: "TV",
  ISO3: "TUV",
  name: "Tuvalu"
}, {
  ISO2: "TW",
  ISO3: "TWN",
  name: "Taiwan, Province of China"
}, {
  ISO2: "TZ",
  ISO3: "TZA",
  name: "Tanzania"
}, {
  ISO2: "UG",
  ISO3: "UGA",
  name: "Uganda"
}, {
  ISO2: "UA",
  ISO3: "UKR",
  name: "Ukraine"
}, {
  ISO2: "UM",
  ISO3: "UMI",
  name: "United States Minor Outlying Islands"
}, {
  ISO2: "UY",
  ISO3: "URY",
  name: "Uruguay"
}, {
  ISO2: "US",
  ISO3: "USA",
  name: "United States"
}, {
  ISO2: "UZ",
  ISO3: "UZB",
  name: "Uzbekistan"
}, {
  ISO2: "VA",
  ISO3: "VAT",
  name: "Vatican City"
}, {
  ISO2: "VC",
  ISO3: "VCT",
  name: "Saint Vincent and the Grenadines"
}, {
  ISO2: "VE",
  ISO3: "VEN",
  name: "Venezuela"
}, {
  ISO2: "VG",
  ISO3: "VGB",
  name: "British Virgin Islands"
}, {
  ISO2: "VI",
  ISO3: "VIR",
  name: "United States Virgin Islands"
}, {
  ISO2: "VN",
  ISO3: "VNM",
  name: "Vietnam"
}, {
  ISO2: "VU",
  ISO3: "VUT",
  name: "Vanuatu"
}, {
  ISO2: "WF",
  ISO3: "WLF",
  name: "Wallis and Futuna"
}, {
  ISO2: "WS",
  ISO3: "WSM",
  name: "Samoa"
}, {
  ISO2: "YE",
  ISO3: "YEM",
  name: "Yemen"
}, {
  ISO2: "ZA",
  ISO3: "ZAF",
  name: "South Africa"
}, {
  ISO2: "ZM",
  ISO3: "ZMB",
  name: "Zambia"
}, {
  ISO2: "ZW",
  ISO3: "ZWE",
  name: "Zimbabwe"
}],
    o = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function m(n, e) {
  return n(e = {
    exports: {}
  }, e.exports), e.exports;
}

var u,
    c,
    s,
    l = m(function (n, e) {
  var a, r;
  n.exports = (a = function a(n) {
    return Array.prototype.toString.call(n);
  }, r = function r(n, e) {
    try {
      var a = document.createElement("canvas");
      a.width = 1, a.height = 1;
      var r = a.getContext("2d");
      return r.textBaseline = "top", r.font = "100px -no-font-family-here-", r.fillStyle = e, r.scale(.01, .01), r.fillText(n, 0, 0), r.getImageData(0, 0, 1, 1).data;
    } catch (n) {
      return !1;
    }
  }, function (n) {
    var e = r(n, "#000"),
        t = r(n, "#fff");
    return e && t && function (n, e) {
      var r = a(n),
          t = a(e);
      return r === t && "0,0,0,0" !== r;
    }(e, t);
  });
}),
    f = "object",
    d = function d(n) {
  return n && n.Math == Math && n;
},
    p = d(typeof globalThis == f && globalThis) || d(typeof window == f && window) || d(typeof self == f && self) || d(typeof o == f && o) || Function("return this")(),
    g = function g(n) {
  try {
    return !!n();
  } catch (n) {
    return !0;
  }
},
    M = !g(function () {
  return 7 != Object.defineProperty({}, "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    h = {}.propertyIsEnumerable,
    A = Object.getOwnPropertyDescriptor,
    y = {
  f: A && !h.call({
    1: 2
  }, 1) ? function (n) {
    var e = A(this, n);
    return !!e && e.enumerable;
  } : h
},
    C = function C(n, e) {
  return {
    enumerable: !(1 & n),
    configurable: !(2 & n),
    writable: !(4 & n),
    value: e
  };
},
    T = {}.toString,
    v = function v(n) {
  return T.call(n).slice(8, -1);
},
    N = "".split,
    G = g(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (n) {
  return "String" == v(n) ? N.call(n, "") : Object(n);
} : Object,
    B = function B(n) {
  if (null == n) throw TypeError("Can't call method on " + n);
  return n;
},
    R = function R(n) {
  return G(B(n));
},
    P = function P(n) {
  return "object" == typeof n ? null !== n : "function" == typeof n;
},
    E = function E(n, e) {
  if (!P(n)) return n;
  var a, r;
  if (e && "function" == typeof (a = n.toString) && !P(r = a.call(n))) return r;
  if ("function" == typeof (a = n.valueOf) && !P(r = a.call(n))) return r;
  if (!e && "function" == typeof (a = n.toString) && !P(r = a.call(n))) return r;
  throw TypeError("Can't convert object to primitive value");
},
    L = {}.hasOwnProperty,
    b = function b(n, e) {
  return L.call(n, e);
},
    K = p.document,
    U = P(K) && P(K.createElement),
    w = function w(n) {
  return U ? K.createElement(n) : {};
},
    F = !M && !g(function () {
  return 7 != Object.defineProperty(w("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    D = Object.getOwnPropertyDescriptor,
    H = {
  f: M ? D : function (n, e) {
    if (n = R(n), e = E(e, !0), F) try {
      return D(n, e);
    } catch (n) {}
    if (b(n, e)) return C(!y.f.call(n, e), n[e]);
  }
},
    V = function V(n) {
  if (!P(n)) throw TypeError(String(n) + " is not an object");
  return n;
},
    j = Object.defineProperty,
    W = {
  f: M ? j : function (n, e, a) {
    if (V(n), e = E(e, !0), V(a), F) try {
      return j(n, e, a);
    } catch (n) {}
    if ("get" in a || "set" in a) throw TypeError("Accessors not supported");
    return "value" in a && (n[e] = a.value), n;
  }
},
    Z = M ? function (n, e, a) {
  return W.f(n, e, C(1, a));
} : function (n, e, a) {
  return n[e] = a, n;
},
    Y = function Y(n, e) {
  try {
    Z(p, n, e);
  } catch (a) {
    p[n] = e;
  }

  return e;
},
    k = m(function (n) {
  var e = p["__core-js_shared__"] || Y("__core-js_shared__", {});
  (n.exports = function (n, a) {
    return e[n] || (e[n] = void 0 !== a ? a : {});
  })("versions", []).push({
    version: "3.1.3",
    mode: "global",
    copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
  });
}),
    J = k("native-function-to-string", Function.toString),
    x = p.WeakMap,
    z = "function" == typeof x && /native code/.test(J.call(x)),
    _ = 0,
    Q = Math.random(),
    X = function X(n) {
  return "Symbol(" + String(void 0 === n ? "" : n) + ")_" + (++_ + Q).toString(36);
},
    q = k("keys"),
    $ = function $(n) {
  return q[n] || (q[n] = X(n));
},
    nn = {},
    en = p.WeakMap;

if (z) {
  var an = new en(),
      rn = an.get,
      tn = an.has,
      Sn = an.set;
  u = function u(n, e) {
    return Sn.call(an, n, e), e;
  }, c = function c(n) {
    return rn.call(an, n) || {};
  }, s = function s(n) {
    return tn.call(an, n);
  };
} else {
  var In = $("state");
  nn[In] = !0, u = function u(n, e) {
    return Z(n, In, e), e;
  }, c = function c(n) {
    return b(n, In) ? n[In] : {};
  }, s = function s(n) {
    return b(n, In);
  };
}

var On = {
  set: u,
  get: c,
  has: s,
  enforce: function enforce(n) {
    return s(n) ? c(n) : u(n, {});
  },
  getterFor: function getterFor(n) {
    return function (e) {
      var a;
      if (!P(e) || (a = c(e)).type !== n) throw TypeError("Incompatible receiver, " + n + " required");
      return a;
    };
  }
},
    on = m(function (n) {
  var e = On.get,
      a = On.enforce,
      r = String(J).split("toString");
  k("inspectSource", function (n) {
    return J.call(n);
  }), (n.exports = function (n, e, t, S) {
    var I = !!S && !!S.unsafe,
        O = !!S && !!S.enumerable,
        i = !!S && !!S.noTargetGet;
    "function" == typeof t && ("string" != typeof e || b(t, "name") || Z(t, "name", e), a(t).source = r.join("string" == typeof e ? e : "")), n !== p ? (I ? !i && n[e] && (O = !0) : delete n[e], O ? n[e] = t : Z(n, e, t)) : O ? n[e] = t : Y(e, t);
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && e(this).source || J.call(this);
  });
}),
    mn = p,
    un = function un(n) {
  return "function" == typeof n ? n : void 0;
},
    cn = function cn(n, e) {
  return arguments.length < 2 ? un(mn[n]) || un(p[n]) : mn[n] && mn[n][e] || p[n] && p[n][e];
},
    sn = Math.ceil,
    ln = Math.floor,
    fn = function fn(n) {
  return isNaN(n = +n) ? 0 : (n > 0 ? ln : sn)(n);
},
    dn = Math.min,
    pn = function pn(n) {
  return n > 0 ? dn(fn(n), 9007199254740991) : 0;
},
    gn = Math.max,
    Mn = Math.min,
    hn = function hn(n, e) {
  var a = fn(n);
  return a < 0 ? gn(a + e, 0) : Mn(a, e);
},
    An = function An(n) {
  return function (e, a, r) {
    var t,
        S = R(e),
        I = pn(S.length),
        O = hn(r, I);

    if (n && a != a) {
      for (; I > O;) {
        if ((t = S[O++]) != t) return !0;
      }
    } else for (; I > O; O++) {
      if ((n || O in S) && S[O] === a) return n || O || 0;
    }

    return !n && -1;
  };
},
    yn = {
  includes: An(!0),
  indexOf: An(!1)
}.indexOf,
    Cn = function Cn(n, e) {
  var a,
      r = R(n),
      t = 0,
      S = [];

  for (a in r) {
    !b(nn, a) && b(r, a) && S.push(a);
  }

  for (; e.length > t;) {
    b(r, a = e[t++]) && (~yn(S, a) || S.push(a));
  }

  return S;
},
    Tn = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    vn = Tn.concat("length", "prototype"),
    Nn = {
  f: Object.getOwnPropertyNames || function (n) {
    return Cn(n, vn);
  }
},
    Gn = {
  f: Object.getOwnPropertySymbols
},
    Bn = cn("Reflect", "ownKeys") || function (n) {
  var e = Nn.f(V(n)),
      a = Gn.f;
  return a ? e.concat(a(n)) : e;
},
    Rn = function Rn(n, e) {
  for (var a = Bn(e), r = W.f, t = H.f, S = 0; S < a.length; S++) {
    var I = a[S];
    b(n, I) || r(n, I, t(e, I));
  }
},
    Pn = /#|\.prototype\./,
    En = function En(n, e) {
  var a = bn[Ln(n)];
  return a == Un || a != Kn && ("function" == typeof e ? g(e) : !!e);
},
    Ln = En.normalize = function (n) {
  return String(n).replace(Pn, ".").toLowerCase();
},
    bn = En.data = {},
    Kn = En.NATIVE = "N",
    Un = En.POLYFILL = "P",
    wn = En,
    Fn = H.f,
    Dn = function Dn(n, e) {
  var a,
      r,
      t,
      S,
      I,
      O = n.target,
      i = n.global,
      o = n.stat;
  if (a = i ? p : o ? p[O] || Y(O, {}) : (p[O] || {}).prototype) for (r in e) {
    if (S = e[r], t = n.noTargetGet ? (I = Fn(a, r)) && I.value : a[r], !wn(i ? r : O + (o ? "." : "#") + r, n.forced) && void 0 !== t) {
      if (typeof S == typeof t) continue;
      Rn(S, t);
    }

    (n.sham || t && t.sham) && Z(S, "sham", !0), on(a, r, S, n);
  }
},
    Hn = String.fromCharCode,
    Vn = String.fromCodePoint;

Dn({
  target: "String",
  stat: !0,
  forced: !!Vn && 1 != Vn.length
}, {
  fromCodePoint: function fromCodePoint(n) {
    for (var e, a = [], r = arguments.length, t = 0; r > t;) {
      if (e = +arguments[t++], hn(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
      a.push(e < 65536 ? Hn(e) : Hn(55296 + ((e -= 65536) >> 10), e % 1024 + 56320));
    }

    return a.join("");
  }
});
mn.String.fromCodePoint;

var jn = function jn(n) {
  return function (e, a) {
    var r,
        t,
        S = String(B(e)),
        I = fn(a),
        O = S.length;
    return I < 0 || I >= O ? n ? "" : void 0 : (r = S.charCodeAt(I)) < 55296 || r > 56319 || I + 1 === O || (t = S.charCodeAt(I + 1)) < 56320 || t > 57343 ? n ? S.charAt(I) : r : n ? S.slice(I, I + 2) : t - 56320 + (r - 55296 << 10) + 65536;
  };
},
    Wn = {
  codeAt: jn(!1),
  charAt: jn(!0)
}.codeAt;

Dn({
  target: "String",
  proto: !0
}, {
  codePointAt: function codePointAt(n) {
    return Wn(this, n);
  }
});

var Zn = function Zn(n, e, a) {
  if (function (n) {
    if ("function" != typeof n) throw TypeError(String(n) + " is not a function");
  }(n), void 0 === e) return n;

  switch (a) {
    case 0:
      return function () {
        return n.call(e);
      };

    case 1:
      return function (a) {
        return n.call(e, a);
      };

    case 2:
      return function (a, r) {
        return n.call(e, a, r);
      };

    case 3:
      return function (a, r, t) {
        return n.call(e, a, r, t);
      };
  }

  return function () {
    return n.apply(e, arguments);
  };
},
    Yn = Function.call,
    kn = function kn(n, e, a) {
  return Zn(Yn, p[n].prototype[e], a);
};

kn("String", "codePointAt");
Dn({
  target: "String",
  proto: !0
}, {
  repeat: "".repeat || function (n) {
    var e = String(B(this)),
        a = "",
        r = fn(n);
    if (r < 0 || r == 1 / 0) throw RangeError("Wrong number of repetitions");

    for (; r > 0; (r >>>= 1) && (e += e)) {
      1 & r && (a += e);
    }

    return a;
  }
});
kn("String", "repeat");

var Jn = Array.isArray || function (n) {
  return "Array" == v(n);
},
    xn = !!Object.getOwnPropertySymbols && !g(function () {
  return !String(Symbol());
}),
    zn = p.Symbol,
    _n = k("wks"),
    Qn = function Qn(n) {
  return _n[n] || (_n[n] = xn && zn[n] || (xn ? zn : X)("Symbol." + n));
},
    Xn = Qn("species"),
    qn = function qn(n, e) {
  var a;
  return Jn(n) && ("function" != typeof (a = n.constructor) || a !== Array && !Jn(a.prototype) ? P(a) && null === (a = a[Xn]) && (a = void 0) : a = void 0), new (void 0 === a ? Array : a)(0 === e ? 0 : e);
},
    $n = [].push,
    ne = function ne(n) {
  var e = 1 == n,
      a = 2 == n,
      r = 3 == n,
      t = 4 == n,
      S = 6 == n,
      I = 5 == n || S;
  return function (O, i, o, m) {
    for (var u, c, s = Object(B(O)), l = G(s), f = Zn(i, o, 3), d = pn(l.length), p = 0, g = m || qn, M = e ? g(O, d) : a ? g(O, 0) : void 0; d > p; p++) {
      if ((I || p in l) && (c = f(u = l[p], p, s), n)) if (e) M[p] = c;else if (c) switch (n) {
        case 3:
          return !0;

        case 5:
          return u;

        case 6:
          return p;

        case 2:
          $n.call(M, u);
      } else if (t) return !1;
    }

    return S ? -1 : r || t ? t : M;
  };
},
    ee = {
  forEach: ne(0),
  map: ne(1),
  filter: ne(2),
  some: ne(3),
  every: ne(4),
  find: ne(5),
  findIndex: ne(6)
},
    ae = Object.keys || function (n) {
  return Cn(n, Tn);
},
    re = M ? Object.defineProperties : function (n, e) {
  V(n);

  for (var a, r = ae(e), t = r.length, S = 0; t > S;) {
    W.f(n, a = r[S++], e[a]);
  }

  return n;
},
    te = cn("document", "documentElement"),
    Se = $("IE_PROTO"),
    Ie = function Ie() {},
    _Oe = function Oe() {
  var n,
      e = w("iframe"),
      a = Tn.length;

  for (e.style.display = "none", te.appendChild(e), e.src = String("javascript:"), (n = e.contentWindow.document).open(), n.write("<script>document.F=Object<\/script>"), n.close(), _Oe = n.F; a--;) {
    delete _Oe.prototype[Tn[a]];
  }

  return _Oe();
},
    ie = Object.create || function (n, e) {
  var a;
  return null !== n ? (Ie.prototype = V(n), a = new Ie(), Ie.prototype = null, a[Se] = n) : a = _Oe(), void 0 === e ? a : re(a, e);
};

nn[Se] = !0;
var oe = Qn("unscopables"),
    me = Array.prototype;
null == me[oe] && Z(me, oe, ie(null));
var ue,
    ce = ee.find,
    se = !0;
"find" in [] && Array(1).find(function () {
  se = !1;
}), Dn({
  target: "Array",
  proto: !0,
  forced: se
}, {
  find: function find(n) {
    return ce(this, n, arguments.length > 1 ? arguments[1] : void 0);
  }
}), ue = "find", me[oe][ue] = !0;
kn("Array", "find");
var le = l("🇧🇹");

var fe = function (O) {
  function o() {
    return a(this, o), r(this, t(o).apply(this, arguments));
  }

  return n(o, I), e(o, [{
    key: "render",
    value: function value() {
      var n = this.props,
          e = n.iso,
          a = n.iso2,
          r = n.svg,
          t = n.size,
          I = n.margin;
      if (!e && !a) return console.error(" Country flag iso (iso 3) or iso2 code is required"), null;
      a && console.warn("iso2 parameter is deprecated, use iso instead");

      var O = function (n) {
        var e, a, r;
        if (2 === n.length) e = n.toLowerCase(), a = e.toUpperCase(), r = i.find(function (n) {
          return n.ISO2 === a;
        });else {
          if (3 !== n.length) throw new Error(n, " is not an ISO 2 nor ISO 3 code");
          {
            var _t = n.toUpperCase();

            r = i.find(function (n) {
              return n.ISO3 === _t;
            }), e = (a = r.ISO2).toLowerCase();
          }
        }
        if (void 0 === r) throw new Error("Could not find a country corresponding to provided ISO:", n);
        var t = null;
        return le && (t = String.fromCodePoint(a.codePointAt(0) + 127397, a.codePointAt(1) + 127397)), {
          emoji: t,
          svg: "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/4x3/{iso2}.svg".replace("{iso2}", e),
          name: r.name
        };
      }(e || a);

      return !0 === r || null === O.emoji ? S.createElement("img", {
        style: {
          height: t,
          marginRight: I.right,
          marginLeft: I.left
        },
        alt: O.name,
        src: O.svg
      }) : S.createElement("span", {
        style: {
          fontSize: t
        },
        role: "img",
        "aria-label": O.name
      }, O.emoji);
    }
  }]), o;
}();

fe.propTypes = {
  iso: O.string.isRequired,
  svg: O.bool,
  size: O.string,
  margin: O.shape({
    left: O.string,
    righ: O.string
  })
}, fe.defaultProps = {
  svg: !1,
  size: "1em",
  margin: {
    left: "0.1em",
    right: "0.2em"
  }
};
export { fe as C };